import api from './client';

// Receipt-cohort normalization Phase-0 census: read-only, JobStore-backed
// (see backend/services/receipt_cohort_census.py + routes/
// admin_receipt_cohort_census.py). Four predicates in one job result:
// receipt-template docs wrongly Unpaid, EUR-defaulted currency, invoice/
// receipt charge-pair duplicates, and the pending_review reason
// distribution. Never writes.
export const receiptCohortCensusAPI = {
  start: () => api.post('/admin/diagnostics/receipt-cohort-census/start'),
  jobStatus: (jobId) => api.get(`/admin/diagnostics/receipt-cohort-census/job-status/${jobId}`),
  jobLatest: () => api.get('/admin/diagnostics/receipt-cohort-census/job-latest'),
};

// Review-routing recompute: re-runs services/review_routing.py::route_invoice
// against every pending_review doc's CURRENT fields (see backend/services/
// review_recompute_backfill.py + routes/admin_review_recompute.py). Preview
// is read-only; Apply clears/narrows reasons via reroute_review and is
// gated on a completed Preview over the same cohort fingerprint.
export const reviewRecomputeAPI = {
  previewChainStart: () => api.post('/admin/diagnostics/review-recompute/preview/chain-start'),
  previewChainStatus: () => api.get('/admin/diagnostics/review-recompute/preview/chain-status'),
  previewChainStop: (chainId) => api.post('/admin/diagnostics/review-recompute/preview/chain-stop', { chain_id: chainId }),
  applyChainStart: () => api.post('/admin/diagnostics/review-recompute/apply/chain-start'),
  applyChainStatus: () => api.get('/admin/diagnostics/review-recompute/apply/chain-status'),
  applyChainStop: (chainId) => api.post('/admin/diagnostics/review-recompute/apply/chain-stop', { chain_id: chainId }),
  jobStatus: (jobId) => api.get(`/admin/diagnostics/review-recompute/job-status/${jobId}`),
  jobLatest: (operation) => api.get(`/admin/diagnostics/review-recompute/job-latest/${operation}`),
};
